module.exports = __webpack_public_path__ + "img/waist.2ff7ad9a.png";